import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'
import mixx from '../../../mixin/mixin.js'

export default {
  name: 'vtaPorComercio',
  mixins: [mixx],
  data() {
    return {
      loading: false,
      tbv: null,
      ventas: [],
      f_c: {
        desde: this.date_rest(this.currentdate(), -30),
        hasta: this.currentdate()
      }

    };
  },


  mounted() {
    $('#cont_r').css("min-height", (window.innerHeight - 101) + "px");
    this.tbv = $('#ventas').DataTable({
      'paging': true,
      'lengthChange': true,
      'searching': true,
      'ordering': true,
      'info': true,
      "order": [],
      "autoWidth": false,
      'autoWidth': true,
      orderCellsTop: true,
      fixedHeader: true,

    });
    $('.box').boxWidget();

  },

  computed: {
    reporte: function () {
      return (
        "/estadisticas/ventas/comercio?dsis=" + window.sssdi +
        "&desde=" +
        this.f_c.desde +
        "&hasta=" +
        this.f_c.hasta
      );
    }
  },

  methods: {
    consultar() {
      this.loading = true;
      this.tbv.clear();
      this.tbv.destroy();
      this.$http
        .post('/estadisticas/ventas/comercio', this.f_c)
        .then(response => {
          const data = response.data.data;
          data.slice(1).forEach(e => {
            for (let i = 2; i < data[0].length; i++) {
              e[i] = this.num_to_many(parseFloat(e[i]).toFixed(2));

            }
          });
          this.tbv = $('#ventas').DataTable({
            'paging': true,
            'lengthChange': true,
            'searching': true,
            'ordering': true,
            'info': true,
            "autoWidth": false,
            'autoWidth': true,
            orderCellsTop: true,
            fixedHeader: true,
            columns: data[0].map(e => {
              return { title: e }
            }),
            data: data.slice(1)

          });
          this.loading = false;
        });

    },

  },

  components: {
    barra,
    barrais,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/estadisticas/vtaPorComercio/index.js